<template>
  <div>
    <h5 class="measurement-title mb-0"> {{$t('dashboard_new_evollu.parameters.sarcopenia')}} </h5>
    <span class="measurement-timestamp"> {{$t('checkup_plus.reports.measurements.last_measurement_date', {date: moment(data.lastMeasurementTimestamp).format('DD/MM/YYYY HH:mm')})}} </span>

    <table class="w-100">
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/sarcopenia.svg">
              <div>
                <h5 class="card-title">{{$t('checkup_plus.reports.measurements.sarcopenia.test_score')}}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="sarcResultData">{{ sarcResultData.value }} {{sarcResultData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="sarcResultData"> <span  style="font-weight: bold">{{ sarcResultData.previousValue || "N/A" }} {{ sarcResultData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/sarcopenia.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.sarcopenia.hand_grip') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="handgripData">{{ handgripData.value }} {{handgripData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="handgripData"> <span  style="font-weight: bold">{{ handgripData.previousValue || "N/A" }} {{ handgripData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/sarcopenia.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.sarcopenia.muscle_estimation') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="muscleData">{{ muscleData.value }} {{muscleData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="muscleData"> <span  style="font-weight: bold">{{ muscleData.previousValue || "N/A" }} {{ muscleData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/sarcopenia.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.sarcopenia.skf_triceps') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="skfTricepsData">{{ skfTricepsData.value }} {{skfTricepsData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="skfTricepsData"> <span  style="font-weight: bold">{{ skfTricepsData.previousValue || "N/A" }} {{ skfTricepsData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/sarcopenia.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.sarcopenia.skf_biceps') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="skfBicepsData">{{ skfBicepsData.value }} {{skfBicepsData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="skfBicepsData"> <span  style="font-weight: bold">{{ skfBicepsData.previousValue || "N/A" }} {{ skfBicepsData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/sarcopenia.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.sarcopenia.skf_calf') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="skfCalfData">{{ skfCalfData.value }} {{skfCalfData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="skfCalfData"> <span  style="font-weight: bold">{{ skfCalfData.previousValue || "N/A" }} {{ skfCalfData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/sarcopenia.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.sarcopenia.skf_thigh') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="skfThighData">{{ skfThighData.value }} {{skfThighData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="skfThighData"> <span  style="font-weight: bold">{{ skfThighData.previousValue || "N/A" }} {{ skfThighData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/sarcopenia.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.sarcopenia.walk_time') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="gspeedData">{{ gspeedData.value }} {{gspeedData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="gspeedData"> <span  style="font-weight: bold">{{ gspeedData.previousValue || "N/A" }} {{ gspeedData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
      </tr>
      <tr v-for="elem in data.results">
        <td colspan="4">
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }}</h5>
              </div>
            </div>
            <span :style="{ color: elem.resultColour }">
              {{ elem.resultName }}
            </span>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/reference_values.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.measurement_reference_values', {measurement: $t('dashboard_new_evollu.parameters.sarcopenia')}) }}</h5>
              </div>
            </div>
            <div>
              <table>
                <tr v-for="elem in elem.referenceValues">
                  <td>
                    {{handleReferenceValuesCriterias(elem)}}
                  </td>
                  <td>
                    {{elem.resultMatchingCriteria}}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/info_circle.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
              {{ elem.recommendations }}
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sarcResultData: null,
      handgripData: null,
      muscleData: null,
      skfTricepsData: null,
      skfBicepsData: null,
      skfCalfData: null,
      skfThighData: null,
      gspeedData: null,
    }
  },
  created() {
    this.data.measurementValues.forEach(elem => {
      if(elem.attributeCode === 'SARC_RESULT') {
        this.sarcResultData = elem
      } else if(elem.attributeCode === 'SARC_HAND_GRIP') {
        this.handgripData = elem
      }else if(elem.attributeCode === 'SARC_BMUSCL_KG') {
        this.muscleData = elem
      }else if(elem.attributeCode === 'SARC_SKF_TRICEPS') {
        this.skfTricepsData = elem
      }else if(elem.attributeCode === 'SARC_SKF_BICEPS') {
        this.skfBicepsData = elem
      }else if(elem.attributeCode === 'SARC_SKF_CALF') {
        this.skfCalfData = elem
      }else if(elem.attributeCode === 'SARC_SKF_THIGH') {
        this.skfThighData = elem
      }else if(elem.attributeCode === 'SARC_GSPEED') {
        this.gspeedData = elem
      }
    })

    //console.log(this.data)
  },
  methods: {
    handleReferenceValuesCriterias(elem) {
      var str = ""
      let index = 0
      let criteriasLength = elem.criteriaList.length
      if(elem.operator === "AND") {
        elem.criteriaList.forEach(elem => {
          str+= `${elem.attributeName} ${elem.criteria} `
          ++index
          if (index < criteriasLength) {
            str += "& "
          }

        })
      }
      return str
    }
  }
}
</script>

<style scoped lang="scss">
.measurement-card {
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}

table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}

</style>
